import React from 'react';
import { usePermission } from '@/hooks/usePermission';

interface PermissionWrapperProps {
  /** 权限码 */
  permission?: string;
  /** 菜单权限码 */
  menuCode?: string;
  /** 按钮权限码 */
  buttonCode?: string;
  /** 子组件 */
  children: React.ReactNode;
  /** 无权限时的占位内容，默认为 null */
  fallback?: React.ReactNode;
  /** 是否显示无权限占位，默认为 false */
  showFallback?: boolean;
}

/**
 * 权限控制包装组件
 * 根据用户权限控制子组件的显示
 */
const PermissionWrapper: React.FC<PermissionWrapperProps> = ({
  permission,
  menuCode,
  buttonCode,
  children,
  fallback = null,
  showFallback = false,
}) => {
  const { hasPermission, hasButtonPermission, hasMenuPermission } =
    usePermission();

  // 检查权限
  const checkPermission = (): boolean => {
    // 如果指定了具体权限码
    if (permission) {
      return hasPermission(permission);
    }

    // 如果指定了菜单和按钮权限码
    if (menuCode && buttonCode) {
      return hasButtonPermission(menuCode, buttonCode);
    }

    // 如果只指定了菜单权限码
    if (menuCode) {
      return hasMenuPermission(menuCode);
    }

    // 如果没有指定任何权限，默认显示
    return true;
  };

  const hasAuth = checkPermission();

  if (hasAuth) {
    return <>{children}</>;
  }

  return showFallback ? <>{fallback}</> : null;
};

export default PermissionWrapper;
